export default "__VITE_ASSET__BUeD$xep__"